import styles from './style.module.scss';
import {
  List,
  Typography,
  Space,
  Divider,
  Row,
  Col,
  Avatar,
  Card,
  Descriptions,
} from 'antd';
import { Button, PageHeader } from 'components';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { DownloadOutlined, UserOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const Single = ({}) => {
  const { t } = useTranslation();
  const { id, ...reest } = useParams();
  let [searchParams, setSearchParams] = useSearchParams();

  const isSuccessUpdatePage = searchParams.get('success') === 'true';

  const title = t('CONVENZIONI E PROMO DIPENDENTI');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Descriptions column={1} bordered>
          <Descriptions.Item label={t('Village')}>
            Lorem ipsum dolor.
          </Descriptions.Item>
          <Descriptions.Item label={t('Titolo')}>
            Lorem ipsum dolor sit.
          </Descriptions.Item>
          <Descriptions.Item label={t('Data Pubblicazione')}>
            {new Date().toDateString()}
          </Descriptions.Item>
          <Descriptions.Item label={t('File')}>
            <Space>
              fileViewer
              <Button type={'primary-white'} icon={<DownloadOutlined />}>
                Scarica file
              </Button>
            </Space>
          </Descriptions.Item>
        </Descriptions>
      </div>
    </div>
  );
};

export default Single;
